module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticStyle: {
      "width": "98%",
      "margin": "10px auto"
    }
  }, [_c('b', [_vm._v("数据统计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("累计审核：100条")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_vm._v("今日审核：0  条")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_vm._v("可审数据：100 条")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handlehqsj
    }
  }, [_vm._v("获取数据")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.chargebackList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户编号",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userphone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cityname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.customername))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小区",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.customerphone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "户型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.housetypename))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面积",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.floorspace))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户需求",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.cluetypes
          }
        }, [_vm._v(_vm._s(scope.row.cluetypes))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "登记日期",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.regtime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showBillWatch(scope.row)
            }
          }
        }, [_vm._v(" 呼叫 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.addPartner(scope.row)
            }
          }
        }, [_vm._v(" 审核 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.totalOne,
      "current-page": _vm.pageIndexOne
    },
    on: {
      "current-change": _vm.currentchangeOne
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "呼叫客户",
      "visible": _vm.isBillWatch,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isBillWatch = $event
      },
      "close": _vm.closeWxsmzf
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('div', [_c('b', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("微信扫一扫，快速呼叫客户")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": _vm.wxSmzfImg
    }
  }), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeWxsmzf
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "审核",
      "custom-class": "registrationRecord",
      "visible": _vm.isInfor,
      "size": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isInfor = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px",
      "margin-top": "-10px"
    }
  }, [_c('b', [_vm._v("客户信息：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("登记日期：" + _vm._s(_vm.createtime))])]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33.33%",
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "客户姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入客户姓名",
      "maxlength": "20"
    },
    model: {
      value: (_vm.khname),
      callback: function($$v) {
        _vm.khname = $$v
      },
      expression: "khname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33.33%",
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "所在城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择所在城市",
      "options": _vm.csOptions,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeszcs
    },
    model: {
      value: (_vm.szcsid),
      callback: function($$v) {
        _vm.szcsid = $$v
      },
      expression: "szcsid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33.33%",
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "小区名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入小区名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.xqname),
      callback: function($$v) {
        _vm.xqname = $$v
      },
      expression: "xqname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33.33%",
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "房屋户型："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择房屋户型"
    },
    model: {
      value: (_vm.fwhx),
      callback: function($$v) {
        _vm.fwhx = $$v
      },
      expression: "fwhx"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33.33%",
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "房屋面积："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入房屋面积",
      "maxlength": "20"
    },
    model: {
      value: (_vm.fwmj),
      callback: function($$v) {
        _vm.fwmj = $$v
      },
      expression: "fwmj"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px",
      "line-height": "36px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("㎡")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('b', [_vm._v("客户需求:")]), _vm._v(" "), _c('span', [_vm._v("（多选）")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.khxqOption), function(option, index) {
    return _c('div', {
      key: option.cluetypeid,
      style: ({
        flex: (index % 2 === 0 && index + 1 === _vm.khxqOption.length) ||
          (index % 2 === 0 && _vm.khxqOption[index + 1] === undefined) ? '0 0 50%' : '0 0 33.33%'
      })
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "margin": "0 15px 15px 0"
      }
    }, [_c('div', {
      staticClass: "khxqcheckbox"
    }, [_c('el-checkbox', {
      model: {
        value: (option.selected),
        callback: function($$v) {
          _vm.$set(option, "selected", $$v)
        },
        expression: "option.selected"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "khxqspan"
    }, [_vm._v(_vm._s(option.cluetypename))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('b', [_vm._v("需求周期：")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "xqzqclass",
      class: {
        'selected': _vm.selectedIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(item.days))])])
  }), 0), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "需求描述：（选填）"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.desc),
      callback: function($$v) {
        _vm.desc = $$v
      },
      expression: "desc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit(1)
      }
    }
  }, [_vm._v("无效客户")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit(0)
      }
    }
  }, [_vm._v("无效需求")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "重要提示",
      "visible": _vm.importantNote,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.importantNote = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', [_vm._v("当前已无数据可审核，请稍后再试。")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.importantNote = false
      }
    }
  }, [_vm._v("我知道了")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "重要提示",
      "visible": _vm.examinevisible,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.examinevisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "95%",
      "margin": "0 auto",
      "margin-bottom": "20px"
    }
  }, [_c('b', [_vm._v("确认当前客户为无效客户吗？提交后该客源数据将不可见，无法变更审核结果。请谨慎操作。")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-top": "10px"
    },
    model: {
      value: (_vm.bzts),
      callback: function($$v) {
        _vm.bzts = $$v
      },
      expression: "bzts"
    }
  }, [_vm._v("不再提示")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.examinevisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handlezyts()
      }
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("审核规则：")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "line-height": "26px",
      "margin-top": "10px"
    }
  }, [_c('li', [_vm._v("1.当可审数据大于0条时，先单击获取要审核的客户数据。")]), _vm._v(" "), _c('li', [_vm._v("2.审核的数据每次最多可获取10条，审核时间为60分钟，若60分钟内没有审核完成，数据将自动刷新释放。")]), _vm._v(" "), _c('li', [_vm._v("3.审核步骤： 先单击呼叫客户，根据弹窗小程序码，进行微信扫码后快速拨号呼叫该客户；关闭呼叫客户弹窗后，单击对应客户审核按钮，进行需求审   核；完成审核后，当前列表数据会自动刷新。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("审核中数据")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#E6A23C",
      "margin-left": "10px"
    }
  }, [_vm._v("当前数据将: 28分29秒后将释放")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9c4231f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/platformManagement/customersourcereview.vue
// module id = 1735
// module chunks = 3